<template>
  <div class="request-approval-container">
    <!-- <Loading v-if="$store.state.globalLoading" /> -->
    <div class="request-approval-dialog">
      <div class="request-approval-content">
        <div class="request-approval-body">
          <div class="req-app-full-container">
            <div class="req-app-full-tittle">
              <p>Permintaan Anda Sedang di Implementasi</p>
              <p>Mohon Untuk Mengisi Kinerja Kami</p>
            </div>
            <div class="req-app-full-wrapper">
              <div class="star-style">
                <span :class="kinerjaPoRating(score, 1)
                  ? 'star-active mr40 pointer'
                  : 'star-deactive mr40 pointer'
                  " @click="chooseScore(1)">&#9733;</span>
                <span :class="kinerjaPoRating(score, 2)
                  ? 'star-active mr40 pointer'
                  : 'star-deactive mr40 pointer'
                  " @click="chooseScore(2)">&#9733;</span>
                <span :class="kinerjaPoRating(score, 3)
                  ? 'star-active mr40 pointer'
                  : 'star-deactive mr40 pointer'
                  " @click="chooseScore(3)">&#9733;</span>
                <span :class="kinerjaPoRating(score, 4)
                  ? 'star-active mr40 pointer'
                  : 'star-deactive mr40 pointer'
                  " @click="chooseScore(4)">&#9733;</span>
                <span :class="kinerjaPoRating(score, 5)
                  ? 'star-active mr40 pointer'
                  : 'star-deactive mr40 pointer'
                  " @click="chooseScore(5)">&#9733;</span>
              </div>
            </div>
            <div class="req-app-full-btn-wrapper">
              <div class="req-app-btn-submit mr10" @click="SubmitCsi()">
                Submit
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../services/config'
export default {
  data() {
    return {
      score: 0,
      isDone: false,
    }
  },
  async created() {
    const { id, status, type, userid } = this.$route.params
    const { data } = await axios({
      method: 'get',
      url: `${api}/api/v1/request/csi/${id}`,
    })

    if (data && data.data) {
      this.score = data.data.csi
      this.isDone = data.data.csi > 0 ? true : false
    }
  },
  methods: {
    chooseScore(value) {
      this.score = value
    },
    SubmitCsi() {
      const { id, status, type, userid } = this.$route.params

      if (this.isDone && this.$store.state.role_id != 2) {
        this.$store.commit('SET_NOTIF', 'CSI Score telah terisi!')
        this.$router.push({ path: '/myrequest' })
      } else {
        if (
          this.$store.state.userid == userid ||
          this.$store.state.role_id == 2
        ) {
          this.$store.dispatch('myRequest/inputCsiScore', {
            id,
            type,
            status,
            score: this.score,
            role_id: this.$store.state.role_id,
          })
        } else {
          this.$store.commit(
            'SET_NOTIF',
            'Maaf, Anda bukan requestor dari tiket ini.'
          )
        }
      }
    },
  },
}
</script>
